import { CurrencyOptionResource, DisableableOption, Id } from "@dgs/core";
import { CategoryOptionResource } from "../../../shared/types/category";
import { CostCategoryOptionResource } from "../../../shared/types/costCategory";
import { EventFormat } from "../../../shared/types/eventFormat";
import { EventTypeOptionResource } from "../../../shared/types/eventType";
import { FeedbackEvaluationResource } from "../../../shared/types/feedback";
import { IndustryOptionResource } from "../../../shared/types/industry";
import { OrganizationalUnitOptionResource } from "../../../shared/types/organizationalUnit";
import { OrganizerOptionResource } from "../../../shared/types/organizer";
import { RegionOptionResource } from "../../../shared/types/region";
import { TargetGroupOptionResource } from "../../../shared/types/targetGroup";
import { TagOptionResource } from "../shared/types";
import { DoughnutValue } from "./DoughnutChart";

export enum AttributeType {
	eventType = "EVENT.EVENT_TYPE",
	organizationalUnits = "EVENT.ORGANIZATIONAL_UNITS",
	industries = "EVENT.INDUSTRIES",
	organizer = "EVENT.ORGANIZER",
	format = "EVENT.FORMAT",
	category = "EVENT.EVENT_CATEGORY",
	targetGroup = "EVENT.TARGET_GROUP",
	region = "EVENT.REGION",
	tags = "EVENT.TAGS",
}

export interface EventAnalyticsFilterValues {
	start: string | null;
	end: string | null;
	attributes: {
		type: AttributeType | null;
		value:
			| (
					| EventTypeOptionResource
					| OrganizationalUnitOptionResource
					| IndustryOptionResource
					| OrganizerOptionResource
					| { name: string; value: EventFormat }
					| CategoryOptionResource
					| TargetGroupOptionResource
					| RegionOptionResource
					| TagOptionResource
			  )[]
			| null;
	}[];
}

export interface AnalyticsEventFilterRequest {
	start: string | null;
	end: string | null;
	attributes: {
		type: AttributeType | null;
		value: Id[] | null;
	}[];
}

export interface EventAnalyticsRatingResource {
	id: Id;
	name: string;
	start: string;
	end: string;
	rating: number;
}

export interface EventAnalyticsRatingCountResource {
	count: number;
	rating: number;
}

export interface EventAnalyticsOverviewResource {
	total: number;
	planned: number;
	past: number;
}

export interface EventAnalyticsResource {
	overview: EventAnalyticsOverviewResource;
	eventTypes: DoughnutValue[];
	organisationalUnits: DoughnutValue[];
	industries: DoughnutValue[];
	organizers: DoughnutValue[];
	formats: DoughnutValue[];
	categories: DoughnutValue[];
	targetGroups: DoughnutValue[];
	regions: DoughnutValue[];
	tags: DoughnutValue[];
	topPerformerEvents: EventAnalyticsRatingResource[];
	lowPerformerEvents: EventAnalyticsRatingResource[];
	eventCountByRating: EventAnalyticsRatingCountResource[];
}

export interface AnalyticsFeedbackEventResource extends DisableableOption {
	id: Id;
	name: string;
	eventTypeName: string;
	start: string;
	end: string;
	rating: number | null;
	creatorName: string | null;
	locationName: string | null;
	participantsCount: number | null;
	feedbackCount: number | null;
	feedbackEvaluation: FeedbackEvaluationResource[];
	metrics: AnalyticsEventMetricResource;
}

export interface AnalyticsFeedbackEventOptionResource extends DisableableOption {
	id: Id;
	name: string;
	eventTypeName: string;
	start: string;
	end: string;
}

export interface AnalyticsEventMetricResource {
	visitorsMetric: number | null;
	invitedPersonsMetric: number | null;
	registrationsMetric: number | null;
	customersMetric: number | null;
	employeesMetric: number | null;
	eventReachMetric: number | null;
	eventGoalRatingMetric: number | null;
}

export interface EventBudgetAnalyticsResource {
	totalEventCosts: EventBudgetAnalyticsCostResource[];
	averageCostsPerEvent: EventBudgetAnalyticsCostResource[];
	acceptedUserRequestCosts: EventBudgetAnalyticsCostResource[];
	contactCosts: EventBudgetAnalyticsCostResource[];
	costsByCategory: EventBudgetAnalyticsCostsByCategoryResource[];
}
export interface EventBudgetAnalyticsCostsByCategoryResource {
	costCategory: CostCategoryOptionResource;
	costs: EventBudgetAnalyticsCostResource[];
}
export interface EventBudgetAnalyticsCostResource {
	costs: number;
	currency: CurrencyOptionResource;
}
